import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/expense/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddExpenseModal from "./Modal"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { Breadcrumbs } from "@mui/material"
import { useState } from "react"

export default function ExpenseList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/" }, { label: "Expenses" }]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Expenses</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <ExpenseTable />
      </CrudProvider>
    </>
  )
}

function ExpenseTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Expense"
        columns={columns}
        apiPath="expense"
        onImport={true}
        onExport={true}
      />

      {openDialog ? <AddExpenseModal /> : null}
    </>
  )
}
